import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../third-party/shadcn/card";
import { formatSeconds } from "../../../utils/number.util";
import { IntegrationItem } from "../../../models/integration-item.model";

export const MetricOverviewRow = ({
  count,
  averageTime,
  monthRuns,
}: {
  count: number;
  averageTime: number;
  monthRuns: IntegrationItem[];
}) => {
  const metrics = [
    {
      label: "Active Integrations",
      value: count,
      hint: null,
    },
    {
      label: "Time to Execute",
      value: formatSeconds(averageTime),
      hint: "average this month",
    },
    {
      label: "Total Failures",
      value: monthRuns.filter((x) => x.conclusion === "failure").length,
      hint: "this month",
    },
    {
      label: "Total Runs",
      value: monthRuns.reduce((acc, cur) => acc + cur.attempt, 0),
      hint: "this month",
    },
  ];

  return (
    <div className="flex gap-3">
      {metrics.map((metric) => (
        <Card
          key={metric.label}
          className="w-1/4 group hover:border-signal/40 transition-colors"
        >
          <CardHeader className="pb-2">
            <CardDescription>{metric.label}</CardDescription>
            <CardTitle className="text-metric text-4xl pt-4 font-medium text-foreground group-hover:text-signal transition-colors">
              {metric.value}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {metric.hint ? (
              <div className="text-[11px] text-muted-foreground tracking-wide">
                {metric.hint}
              </div>
            ) : (
              <div className="h-4" />
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
